"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.writingStyles.disabled': 'Funkcja stylów pisania nie jest dostępna w Twoim obecnym planie.',
};
